<template>
  <div id="home">
    <v-layout rows wrap>
      <v-flex xs12 sm12 md6>
        <v-container fluid grid-list-sm>
          <h3 class="grey--text text-md-center">MÓDULOS</h3><br/>
          <v-layout row wrap>
            <v-flex v-if="roles.indexOf('caja_chica') >= 0" md6 pb-3>
              <v-container>
                <router-link to="/solicitudes/cajachica" tag="button">
                  <img src="@/assets/icons/cajaChica.png" height="200" width="auto" style="opacity:0.8">
                </router-link>
              </v-container>
            </v-flex>
            <v-flex v-if="roles.indexOf('caja_chica') >= 0" md6 pb-3>
              <v-container>
                <router-link to="/solicitudes/reposicionfondo" tag="button">
                  <img src="@/assets/icons/reposicion.png" height="200" width="auto" style="opacity:0.8">
                </router-link>
              </v-container>
            </v-flex>
            <v-flex v-if="roles.indexOf('gastos_viaje') >= 0" md6 pb-3>
              <v-container>
                <router-link to="/solicitudes/gastosviaje" tag="button">
                  <img src="@/assets/icons/gastosViaje.png" height="200" width="auto" style="opacity:0.8">
                </router-link>
              </v-container>
            </v-flex>
            <v-flex md6 pb-3>
              <v-container>
                <router-link to="/notificaciones" tag="button">
                  <img src="@/assets/icons/notificaciones.png" height="200" width="auto" style="opacity:0.8">
                </router-link>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs12 sm12 md6>
        <v-container>
          <h3 class="grey--text text-md-center">NOTIFICACIONES</h3><br/>
          <v-tabs v-model="tab_activo" v-show="(!loading && tab_activo == 0) || tab_activo == 1" color="blue-grey" dark slider-color="error" class="elevation-12">
            <v-tab ripple>
              No leídos
            </v-tab>
            <v-tab-item>
              <v-container>
                <v-expansion-panel popout focusable dark>
                  <template v-if="notificaciones.length">
                    <v-expansion-panel-content v-for="(item, i) in notificaciones" :key="i">
                      <div v-if="observaciones[i] === ''" slot="header">
                        <strong><span style="color:#2196F3;">APROBACIÓN</span>&nbsp;&nbsp;&nbsp;{{ item.tipo + ' - ' + item.movimiento + ' - ' + item.fecha_registro }}</strong>
                      </div>
                      <div v-else slot="header"><strong><span style="color:#2196F3;">MENSAJE</span>&nbsp;&nbsp;&nbsp;{{ item.tipo + ' - ' + item.movimiento + ' - ' + item.fecha_registro }}</strong></div>
                      <v-card light>
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex xs12 sm12 md6>
                              <p>
                                <strong>Beneficiario:</strong> {{ item.nombre }} ({{ item.usuario }})
                              </p>
                              <p>
                                <strong>Tipo de solicitud:</strong> {{ item.tipo }}
                              </p>
                              <p>
                                <strong>Movimiento:</strong> {{ item.movimiento }}
                              </p>
                              <p>
                                <strong>Fecha:</strong> {{ item.fecha_registro }}
                              </p>
                              <p>
                                <strong>Firma:</strong> {{ item.firma }}
                              </p>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                              <p v-if="item.resumen && item.resumen.unidad_negocio">
                                <strong>Unidad de negocio:</strong> {{ item.resumen.unidad_negocio }}
                              </p>
                              <p v-if="item.resumen && item.resumen.ubicacion">
                                <strong>Ubicación:</strong> {{ item.resumen.ubicacion }}
                              </p>
                              <p v-if="item.resumen && item.resumen.puesto">
                                <strong>Puesto:</strong> {{ item.resumen.puesto }}
                              </p>
                              <p v-if="item.resumen && item.resumen.centro_costos">
                                <strong>Centro de costos:</strong> {{ item.resumen.centro_costos }}
                              </p>
                              <p v-if="item.resumen && item.resumen.empresa">
                                <strong>Empresa:</strong> {{ item.resumen.empresa }}
                              </p>
                              <p v-if="item.resumen && item.resumen.monto">
                                <strong>Monto:</strong> {{ '$ ' + item.resumen.monto.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                              </p>
                              <p v-if="item.resumen && item.resumen.dias_viaje">
                                <strong>Días de viaje:</strong> {{ item.resumen.dias_viaje }}
                              </p>
                              <p v-if="item.resumen && item.resumen.destino">
                                <strong>Destino:</strong> {{ item.resumen.destino }}
                              </p>
                              <p v-if="item.resumen && item.resumen.importe_anticipo">
                                <strong>Importe de Anticipo:</strong> {{ '$ ' + item.resumen.importe_anticipo.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                              </p>
                              <p v-if="item.resumen && item.resumen.importe_comprobado">
                                <strong>Importe Comprobado:</strong> {{ '$ ' + item.resumen.importe_comprobado.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                              </p>
                              <p v-if="item.resumen && item.resumen.importe_restante">
                                <strong>Importe Restante:</strong> {{ '$ ' + item.resumen.importe_restante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' MXN' }}
                              </p>
                            </v-flex>
                          </v-layout>
                          <p v-if="observaciones[i] !== ''">
                            <strong>Observaciones:</strong> {{ item.observaciones }}
                          </p>
                          <v-text-field v-else v-model="notificaciones[i].observaciones" :error-messages="observacionesErrors(i)"
                          @input="$v.notificaciones.$each[i].observaciones.$touch()"
                          @blur="$v.notificaciones.$each[i].observaciones.$touch()" label="Observaciones"></v-text-field>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn dark color="blue-grey" @click="showDetailReq(notificaciones[i].id)">
                            Detalle
                            <v-icon right dark>description</v-icon>
                          </v-btn>
                          <template v-if="observaciones[i] === ''">
                            <v-btn dark color="error" @click="notificacion = notificaciones[i]; questionReject = true">
                              Rechazar
                              <v-icon right dark>clear</v-icon>
                            </v-btn>
                            <v-btn dark color="success" @click="notificacion = notificaciones[i]; questionApprove = true">
                              Aprobar
                              <v-icon right dark>check</v-icon>
                            </v-btn>
                          </template>
                          <template v-else>
                            <v-btn dark color="blue-grey" @click="notificacion = notificaciones[i]; questionRemove = true">
                              Marcar como leído
                            </v-btn>
                          </template>
                        </v-card-actions>
                      </v-card>
                    </v-expansion-panel-content>
                  </template>
                  <template v-else>
                    <v-card light>
                      <v-card-text>
                        <div class="text-xs-center">
                          <v-btn v-if="!loading" @click="refresh()" round dark small color="blue-grey">
                            <v-icon dark>loop</v-icon>
                          </v-btn>
                          <p>
                            <h3 v-if="!loading">No se obtuvieron elementos</h3>
                            <h3 v-else>Cargando elementos...</h3>
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-expansion-panel>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-container>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogDetailReq" persistent width="500">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Detalle de la solicitud</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <template v-for="(elem, i) in detalle">
              <template v-if="elem.titulo === '__title__'">
                <h3 class="grey--text">{{ elem.valor }}</h3><br/>
              </template>
              <template v-else-if="elem.titulo === '__divider__'">
                <v-divider></v-divider><br/>
              </template>
              <template v-else-if="elem.titulo === '__resumen__'">
                <h3 class="grey--text">RESUMEN</h3><br/>
                <v-data-table v-if="resumen.length" :headers="headersResumen" :items="tableResumen" class="elevation-1" hide-actions no-data-text="">
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-right">{{ props.item.tipo_gasto }}</td>
                    <td class="text-xs-right">{{ props.item.concepto }}</td>
                    <td class="text-xs-right">{{ props.item.fecha_timbrado }}</td>
                    <!--<td class="text-xs-right">{{ props.item.proveedor }}</td>-->
                    <td class="text-xs-right">{{ props.item.subtotal }}</td>
                    <td class="text-xs-right">{{ props.item.iva }}</td>
                    <td class="text-xs-right">{{ props.item.total }}</td>
                  </template>
                </v-data-table>
                <br/>
              </template>
              <v-btn v-else-if="elem.titulo === '__id__' && roles.indexOf('contabilidad') >= 0" flat :loading="loading"
              color="blue-grey" class="white--text" @click="id_documento = elem.valor; dialogNewConcept = true">
                Actualizar concepto
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__Pagare') >= 0" flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument(elem.valor)">
                Pagaré
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__Responsiva') >= 0" flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument(elem.valor)">
                Carta responsiva
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__Foto') >= 0" flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument(elem.valor)">
                Foto
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__PDF') >= 0" flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument(elem.valor)">
                PDF
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <v-btn v-else-if="elem.titulo.search('__XML') >= 0" flat :loading="loading" color="blue-grey" class="white--text" @click="downloadDocument(elem.valor)">
                XML
                <v-icon right dark>cloud_download</v-icon>
              </v-btn>
              <template v-else-if="elem.titulo !== '__id__' && elem.valor !== ''">
                <v-text-field v-if="(elem.titulo.search('__Importe') >= 0 && elem.titulo.search('__Importe con letra') < 0) || elem.titulo.search('Fondo fijo autorizado') >= 0 ||
                elem.titulo.search('__Nuevo importe') >= 0 || elem.titulo.search('__Importe por reembolsar') >= 0 ||
                elem.titulo.search('__Subtotal') >= 0 || elem.titulo.search('__Descuento') >= 0 ||
                elem.titulo.search('__IVA') >= 0 || elem.titulo.search('__Total') >= 0 || elem.titulo.search('__Importe total') >= 0"
                :label="elem.titulo.replace(/__(\d+)__/, '')" box readonly :value="elem.valor.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')" prefix="$" suffix="MXN"></v-text-field>
                <v-text-field v-else :label="elem.titulo.replace(/__(\d+)__/, '')" box readonly :value="elem.valor"></v-text-field>
              </template>
            </template><br/>
            <h3 class="grey--text">FIRMAS</h3><br/>
            <v-list three-line dark>
              <template v-for="(item, i) in firmas">
                <v-list-tile class="pb-2 pt-2">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                    <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                    <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-show="(i + 1) < firmas.length"></v-divider>
              </template>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue-grey" @click.native="closeDetailReq()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNewConcept" persistent width="450">
      <v-card>
        <v-toolbar dense dark color="blue-grey">
          <v-toolbar-title>Nuevo concepto</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-select v-model="nuevo_conceptoo" :items="conceptos"
            item-text="descripcion" item-value="id" label="Concepto"></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="blue-grey" @click.native="closeNewConcept()">Cerrar</v-btn>
          <v-btn color="blue-grey" class="white--text" @click.native="updateNewConcept()">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionRemove" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea marcar como leída la notificación?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionRemove = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="removeNotification()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionReject" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea rechazar la solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionReject = false">Cancelar</v-btn>
          <v-btn flat color="error" @click.native="rejectRequest()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="questionApprove" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">¿Desea aprobar la solicitud?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="questionApprove = false">Cancelar</v-btn>
          <v-btn flat color="orange" @click.native="approveRequest()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" right>
      {{ msgError }}
    </v-snackbar>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando información
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minValue, maxValue, maxLength, integer, decimal } from 'vuelidate/lib/validators'
import axios from 'axios'
import services from '@/config/services'
import download from 'downloadjs'

export default {
  name: 'home',
  mixins: [validationMixin],
  validations: {
    notificaciones: {
      $each: {
        observaciones: { maxLength: maxLength(300) }
      }
    }
  },
  data: () => ({
    loading: false,
    success: false,
    error: false,
    msgSuccess: '',
    msgError: '',
    dialogDetailReq: false,
    dialogNewConcept: false,
    questionRemove: false,
    questionReject: false,
    questionApprove: false,
    roles: [],
    tab_activo: null,
    notificaciones: [],
    leidos: [],
    pagina_notificaciones: 1,
    pagina_leidos: 1,
    total_notificaciones: 0,
    total_leidos: 0,
    notificacion: {
      id: null,
      nombre: '',
      tipo: '',
      movimiento: '',
      fecha_registro: '',
      fecha_actualizacion: '',
      observaciones: '',
      firma: ''
    },
    observaciones: [],
    conceptos: [],
    nuevo_conceptoo: '',
    id_notificacion: '',
    id_documento: '',
    detalle: [],
    resumen: [],
    firmas: [],
    headersResumen: [
      { text: 'TIPO DE GASTO', align: 'center', sortable: false, value: 'tipo_gasto' },
      { text: 'CONCEPTO', align: 'center', sortable: false, value: 'concepto' },
      { text: 'FECHA DE TIMBRADO', align: 'center', sortable: false, value: 'fecha_timbrado' },
      /*{ text: 'PROVEEDOR', align: 'center', sortable: false, value: 'proveedor' },*/
      { text: 'SUB TOTAL', align: 'center', sortable: false, value: 'subtotal' },
      { text: 'IVA', align: 'center', sortable: false, value: 'iva' },
      { text: 'TOTAL', align: 'center', sortable: false, value: 'total' }
    ]
  }),
  mounted() {
    this.refresh()
    this.ws('get', 'check')
      .then(res => {
        if (res.ok) {
          this.roles = res.data.roles
        }
      })
  },
  computed: {
    tableResumen() {
      let resumen = []
      let detalle = {}
      for (let i = 0; i < this.resumen.length; i++) {
        let tipo_gasto = this.resumen[i].tipo_gasto
        let concepto = this.resumen[i].concepto
        let fecha_timbrado = this.resumen[i].fecha_timbrado
        let proveedor = this.resumen[i].razon_social
        let subtotal = this.resumen[i].subtotal
        let iva = this.resumen[i].iva
        let total = this.resumen[i].total
        if (tipo_gasto === 'deducible') {
          tipo_gasto = 'DEDUCIBLE'
        }
        else if (tipo_gasto === 'no_deducible') {
          tipo_gasto = 'NO DEDUCIBLE'
        }
        if (!detalle[tipo_gasto]) {
          detalle[tipo_gasto] = {}
        }
        if (!detalle[tipo_gasto][concepto]) {
          detalle[tipo_gasto][concepto] = {
            fecha_timbrado: fecha_timbrado,
            proveedor: proveedor,
            subtotal: 0,
            iva: 0,
            total: 0
          }
        }
        detalle[tipo_gasto][concepto].subtotal += subtotal
        detalle[tipo_gasto][concepto].iva += iva
        detalle[tipo_gasto][concepto].total += total
      }
      let keysTipoGasto = Object.keys(detalle)
      for (let i = 0; i < keysTipoGasto.length; i++) {
        let keysConcepto = Object.keys(detalle[keysTipoGasto[i]])
        for (let j = 0; j < keysConcepto.length; j++) {
          resumen.push({
            tipo_gasto: keysTipoGasto[i],
            concepto: keysConcepto[j],
            fecha_timbrado: detalle[keysTipoGasto[i]][keysConcepto[j]].fecha_timbrado,
            proveedor: detalle[keysTipoGasto[i]][keysConcepto[j]].proveedor,
            subtotal: detalle[keysTipoGasto[i]][keysConcepto[j]].subtotal,
            iva: detalle[keysTipoGasto[i]][keysConcepto[j]].iva,
            total: detalle[keysTipoGasto[i]][keysConcepto[j]].total
          })
        }
      }
      for (let i = 0; i < resumen.length; i++) {
        resumen[i].fecha_timbrado = resumen[i].fecha_timbrado.split("T")[0]
        resumen[i].subtotal = '$' + resumen[i].subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        resumen[i].iva = '$' + resumen[i].iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        resumen[i].total = '$' + resumen[i].total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
      return resumen
    }
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    refresh() {
      this.loading = true
      this.notificaciones = []
      this.leidos = []
      this.pagina_notificaciones = 1
      this.pagina_leidos = 1
      setTimeout(() => {
        this.ws('get', 'notificaciones', { pagina_notificaciones: this.pagina_notificaciones,
                                           pagina_leidos: this.pagina_leidos })
          .then(res => {
            if (res.ok) {
              this.notificaciones = res.data.notificaciones
              this.leidos = res.data.leidos
              this.total_notificaciones = res.data.total_notificaciones
              this.total_leidos = res.data.total_leidos
              this.observaciones = []
              for (let i = 0; i < this.notificaciones.length; i++) {
                this.observaciones.push(this.notificaciones[i].observaciones);
              }
            }
            else {
              this.notificacion = {
                id: null,
                nombre: '',
                tipo: '',
                movimiento: '',
                fecha_registro: '',
                fecha_actualizacion: '',
                observaciones: '',
                firma: ''
              }
            }
          })
          .finally(() => {
            this.loading = false
          })
      }, 500)
    },
    observacionesErrors(i) {
      const errors = []
      if (!this.$v.notificaciones.$each[i].observaciones.$dirty) return errors
      !this.$v.notificaciones.$each[i].observaciones.maxLength && errors.push('El campo excede la longitud máxima')
      return errors
    },
    close() {
      this.$v.$reset()
      this.notificacion = {
        id: null,
        nombre: '',
        tipo: '',
        movimiento: '',
        fecha_registro: '',
        fecha_actualizacion: '',
        observaciones: '',
        firma: ''
      }
    },
    removeNotification() {
      this.questionRemove = false
      this.loading = true
      let data = {
        id: this.notificacion.id
      }
      this.ws('post', 'eliminarNotificacion', data)
        .then(res => {
          if (res.ok) {
            this.close()
            this.refresh()
            this.success = true
            this.msgSuccess = res.message
          }
          else {
            this.loading = false
            this.error = true
            this.msgError = res.message
          }
        })
    },
    rejectRequest() {
      this.questionReject = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.notificacion.observaciones !== '') {
          this.loading = true
          let data = {
            id: this.notificacion.id,
            observaciones: this.notificacion.observaciones
          }
          this.ws('post', 'rechazarSolicitud', data)
            .then(res => {
              if (res.ok) {
                this.close()
                this.refresh()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.loading = false
                this.error = true
                this.msgError = res.message
              }
            })
        }
        else {
          this.error = true
          this.msgError = 'El campo observaciones es obligatorio'
        }
      }
    },
    approveRequest() {
      this.questionApprove = false
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let data = {
          id: this.notificacion.id,
          observaciones: this.notificacion.observaciones
        }
        this.ws('post', 'aprobarSolicitud', data)
          .then(res => {
            if (res.ok) {
              this.close()
              this.refresh()
              this.success = true
              this.msgSuccess = res.message
            }
            else {
              this.loading = false
              this.error = true
              this.msgError = res.message
            }
          })
      }
    },
    closeDetailReq() {
      this.id_notificacion = ''
      this.id_documento = ''
      this.nuevo_conceptoo = ''
      this.detalle = []
      this.resumen = []
      this.firmas = []
      this.dialogDetailReq = false
    },
    closeNewConcept() {
      this.id_documento = ''
      this.nuevo_conceptoo = ''
      this.dialogNewConcept = false
    },
    updateNewConcept() {
      if (this.roles.indexOf('contabilidad') >= 0) {
        if (this.nuevo_conceptoo != '') {
          let data = {
            id_notificacion: this.id_notificacion,
            id_documento: this.id_documento,
            concepto: this.nuevo_conceptoo
          }
          this.closeNewConcept()
          this.loading = true
          this.ws('post', 'actualizarConceptoDocumento', data)
            .then(res => {
              if (res.ok) {
                this.closeDetailReq()
                this.success = true
                this.msgSuccess = res.message
              }
              else {
                this.loading = false
                this.error = true
                this.msgError = res.message
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
        else {
          this.error = true
          this.msgError = 'Debe seleccionar un concepto disponible'
        }
      }
      else {
        this.error = true
        this.msgError = 'No cuenta con los permisos necesarios para realizar esta acción'
      }
    },
    downloadDocument(doc) {
      let nombre = doc.nombre
      let data = doc.data
      if (data !== null && data !== '') {
        let mimetype = data.split(';')[0].split(':')[1]
        download(data, nombre, mimetype)
      }
      else {
        this.error = true
        this.msgError = 'El documento no se encuentra disponible'
      }
    },
    prepareDetailForm(data) {
      for (let i = 0; i < data.detalle.length; i++) {
        let keys = []
        for (var k in data.detalle[i]) {
          if (data.detalle[i].hasOwnProperty(k)) {
            keys.push(k);
          }
        }
        keys.sort()
        for (let j = 0; j < keys.length; j++) {
          this.detalle.push({
            titulo: keys[j],
            valor: data.detalle[i][keys[j]]
          })
        }
      }
      this.resumen = data.resumen
      this.firmas = data.firmas
      this.conceptos = data.conceptos
      this.dialogDetailReq = true
    },
    showDetailReq(id) {
      this.loading = true
      this.ws('get', 'detalleCompletoSolicitud', { id })
        .then(res => {
          if (res.ok) {
            this.id_notificacion = id
            this.prepareDetailForm(res.data)
          }
          else {
            this.loading = false
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
